export const QUERY_KEYS = {
  AUTH_ME: "auth-me",    // Para /auth/me
  CLINIC_ME: "clinic-me", // Para /clinics/me
  ME: "me",
  DASHBOARD: "dashboard",
  FUNNEL: "funnel",
  ONBOARDING_STATUS: "onboarding-status",
  SPECIALTY: "specialty",
  SPECIALTIES: "specialties",
  EXERCISE: "exercise",
  EXERCISES: "exercises",
  EXERCISE_CATEGORY: "exercise-category",
  EXERCISE_CATEGORIES: "exercise-categories",
  SERVICE: "service",
  SERVICES: "services",
  HELP_ARTICLE: "help-article",
  HELP_ARTICLES: "help-articles",
  SERVICE_CATEGORY: "help-article-category",
  SERVICE_CATEGORIES: "help-article-categories",
  HELP_ARTICLE_CATEGORY: "service-category",
  HELP_ARTICLE_CATEGORIES: "service-categories",
  BOOKING: "booking",
  BOOKINGS: "bookings",
  INVOICES: "invoices",
  AVAILABILITY: "availability",
  AVAILABILITIES: "availabilities",
  AVAILABILITY_ESCEPTION: "availability-exception",
  AVAILABILITY_ESCEPTIONS: "availability-exceptions",
  BLOCKED_SLOT: "blocked-slot",
  BLOCKED_SLOTS: "blocked-slots",
  SLOTS: "slots",
  INVITATION: "invitation",
  INVITATIONS: "invitations",
  LIST: "list",
  STAFF: "staff",
  OWNER: "owner",
  OWNERS: "owners",
  PROFESSIONAL: "professional",
  PROFESSIONALS: "professionals",
  PATIENT: "patient",
  PATIENTS: "patients",
  CLINIC: "clinic",
  CLINICS: "clinics",
  TENANT_SETTINGS: "tenant-settings",
  SUPERADMIN_SETTINGS: "superadmin-settings",
  PUBLIC_SYSTEM_SETTINGS: "public-system-settings",
  BILLING_PORTAL: "billing-portal",
  SUBSCRIPTION: "subscription",
  PUBLIC_PLANS: "public-plans",
  PATIENT_PROFILE: "patient-profile",
  PAST_PREVIEW: "past-preview",
  UPCOMING: "upcoming",
  INFINITE: "infinite",
  PUBLIC_CLINIC: "public-clinic",
  BOOKING_SESSION: "booking-session",
  PROTOCOL: "protocol",
  PROTOCOLS: "protocols",
  RECOVERY_PLAN: "recovery-plan",
  PLATFORM_EXERCISE_CATEGORIES: "platform-exercise-categories",
  PLATFORM_EXERCISE_CATEGORY: "platform-exercise-category",
  PLATFORM_EXERCISES: "platform-exercises",
  PLATFORM_EXERCISE: "platform-exercise",
  PLATFORM_PROTOCOLS: "platform-protocols",
  PLATFORM_PROTOCOL: "platform-protocol",
  PLATFORM_SPECIALTIES: "platform-specialties",
  PLATFORM_SPECIALTY: "platform-specialty",
  PLATFORM_SERVICE_CATEGORIES: "platform-service-categories",
  PLATFORM_SERVICE_CATEGORY: "platform-service-category",
  PLATFORM_SERVICES: "platform-services",
  PLATFORM_SERVICE: "platform-service",
} as const;
